(() => {
    "use strict";
    var __webpack_exports__ = {};
    PLUG.SearchApi = function(config) {
        const {
            apiKey,
            pageSize
        } = config;
        const badSortCriteria = [];
        const baseUrl = "https://searchserverapi1.com/getresults";
        if (!apiKey) {
            throw new Error("SearchApi: No API key found.")
        }
        async function fetchResults(options) {
            const t0 = Date.now();
            const params = [
                ["apiKey", apiKey],
                ["pageStartIndex", String(options.pageNum)],
                ["maxResults", String(pageSize)],
                ["categories", "true"],
                ["facets", "true"],
                ["facetsShowUnavailableOptions", "true"],
                ["categoriesMaxResults", "100"]
            ];
            if (options.pageNum !== 1) {
                params.push(["startIndex", String((options.pageNum - 1) * pageSize)])
            }
            if (options.collection) {
                // params.push(["restrictBy[collections]", options.collection.title]);
                params.push(["collection", options.collection.handle])
            }
            if (options.filters) {
                Object.keys(options.filters).forEach((attribute => {
                    params.push([`restrictBy[${attribute}]`, options.filters[attribute].join("|")])
                }))
            }
            if (options.query) {
                params.push(["q", options.query])
            }
            if (options.sort && options.sort.criteria && options.sort.order) {
                params.push(["sortBy", options.sort.criteria], ["sortOrder", options.sort.order])
            }
            const searchParams = new URLSearchParams(params);
            // Guard the request with a timeout so a hung request (flaky mobile network) surfaces
            // an error instead of leaving the grid stuck on skeletons / blank.
            const controller = new AbortController();
            const requestTimeout = setTimeout((() => controller.abort()), 15000);
            let result;
            try {
                result = await fetch(`${baseUrl}?${searchParams.toString()}`, {
                    signal: controller.signal
                }).then((data => data.json()))
            } finally {
                clearTimeout(requestTimeout)
            }
            if (result.error && result.error === "SORT_ATTRIBUTE_WASNT_FOUND") {
                console.log("WARNING: Invalid sort criteria.");
                badSortCriteria.push(options.sort.criteria);
                return await fetchResults(Object.assign(options, {
                    sort: {
                        criteria: undefined,
                        order: undefined
                    }
                }))
            }
            const items = result.items;
            const productIds = items.map((item => item.product_id));
            const ratings = await fetchProductRatings(productIds);
            const products = items.map(((item, index) => searchResultProductToPlugCollectionProduct(item, ratings[index])));
            const appFacets = result.facets;
            const facets = appFacets.map(appFacetToFacet);
            console.log({
                result,
                ratings
            });
            console.log(`Fetch time: ${Date.now()-t0}ms`);
            return {
                products,
                facets,
                totalItemCount: result.totalItems
            }
        }
        async function fetchProductRatings(productIds) {
            const junipStoreKey = "9WRGWb5HmWjwkVsSQHVXmr1e";
            try {
                const response = await fetch(`https://api.juniphq.com/v1/products?filter[remote_ids]=$`, {
                    method: "GET",
                    headers: {
                        "Junip-Store-Key": junipStoreKey
                    }
                });
                const data = await response.json();
                const overviews = data.products;
                return productIds.map((productId => {
                    const overview = overviews.find((overview => overview.remote_id === productId));
                    if (overview && overview.rating_count > 0) {
                        return {
                            average: overview.rating_average,
                            count: overview.rating_count
                        }
                    } else {
                        return null
                    }
                }))
            } catch (e) {
                console.error(e);
                return []
            }
        }

        function searchResultProductToPlugCollectionProduct(item, rating) {
          // console.log("item",item.quantity);
            return {
                available: item.shopify_variants.some((variant => variant.available === "1")),
                id: item.product_id,
                images: item.shopify_images,
                imageAltTexts: item.shopify_images_alt,
                rating,
                price: item.price, 
                listPrice: item.list_price,
                tags: item.tags.split("[:ATTR:]"),
                title: item.title,
                url: item.link,
                variants: item.shopify_variants.map((v => searchResultVariantToPlugCollectionVariant(v))),
                availablequantity: item.quantity,
                vendor: item.vendor
            }
        }

        function searchResultVariantToPlugCollectionVariant(itemVariant) {
            const variant = {
                available: itemVariant.available === "1",
                filterMetafieldData: itemVariant.filter_variant_metafields_data,
                id: itemVariant.variant_id,
                image: itemVariant.image_link,
                imageAltText: itemVariant.image_alt,
                options: itemVariant.options,
                searchMetafieldData: itemVariant.search_variant_metafield_data,
                sku: itemVariant.sku,
                url: itemVariant.link
            };
            const variantKeys = Object.keys(itemVariant);
            const listPriceKey = variantKeys.find((key => key.startsWith("list_price") && key.endsWith(PLUG.selectedCurrency)));
            const priceKey = variantKeys.find((key => key.startsWith("price") && key.endsWith(PLUG.selectedCurrency)));
            // Searchanise returns "0"/empty for presentment currencies it has not synced (e.g. EGP),
            // which rendered every card as "LE 0.00". When the per-currency value is missing or zero,
            // fall back to the base price converted with Shopify's active rate (matches the native cards).
            const plugCurrencyRate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
            const resolvePresentmentPrice = ((currencyKey, baseValue) => {
                const currencyValue = currencyKey ? itemVariant[currencyKey] : baseValue;
                if (parseFloat(currencyValue) > 0) return currencyValue;
                const baseAmount = parseFloat(baseValue);
                return baseAmount > 0 ? (baseAmount * plugCurrencyRate).toString() : (currencyValue || "0.0000")
            });
            if (listPriceKey) {
                variant.compareAtPrice = resolvePresentmentPrice(listPriceKey, itemVariant.list_price)
            } else {
                variant.compareAtPrice = "0.0000"
            }
            variant.price = resolvePresentmentPrice(priceKey, itemVariant.price);
            return variant
        }

        function appFacetToFacet(appFacet) {
            return {
                attribute: appFacet.attribute,
                buckets: appFacet.buckets,
                dataType: appFacet.data_type,
                defaultTitle: appFacet.default_title,
                defaultView: appFacet.default_view,
                desktopView: appFacet.desktop_view,
                moreCount: Number(appFacet.more_count),
                showOnMobile: appFacet.show_on_mobile === "Y",
                title: appFacet.title,
                type: appFacet.type
            }
        }

        function sortValueToParams(value) {
            value = value.toLowerCase();
            let criteria;
            let order;
            if (value === "featured" && PLUG.requestPageType === "collection" && !badSortCriteria.includes(`collection_${PLUG.collection.id}_position`)) {
                criteria = `collection_${PLUG.collection.id}_position`;
                order = "asc"
            } else if (value === "price: low to high") {
                criteria = "price";
                order = "asc"
            } else if (value === "price: high to low") {
                criteria = "price";
                order = "desc"
            }
            return {
                criteria,
                order
            }
        }

        function paramsToSortValue(sortParams) {
            const criteria = sortParams.criteria ? sortParams.criteria.toLowerCase() : undefined;
            if (criteria && criteria === "price") {
                if (sortParams.order === "asc") {
                    return "Price: Low to High"
                } else if (sortParams.order === "desc") {
                    return "Price: High to Low"
                }
            }
            return "Featured"
        }
        return Object.freeze({
            fetchResults,
            sortValueToParams,
            paramsToSortValue
        })
    };
    (function() {
        class PlugRangeSlider extends HTMLElement {
            constructor() {
                super();
                PLUG.classUtils.bindThisToAllMethods(this)
            }
            connectedCallback() {
                this.minValue = Number(this.dataset.minValue);
                this.maxValue = Number(this.dataset.maxValue);
                this.totalRange = this.maxValue - this.minValue;
                this.onChangeHandlers = [];
                this.elements = {
                    textInputStart: this.querySelector("[data-range-start]"),
                    textInputEnd: this.querySelector("[data-range-end]"),
                    controlStart: this.querySelector(".plug-control-start"),
                    controlEnd: this.querySelector(".plug-control-end"),
                    activeLine: this.querySelector(".plug-range-slider__active-line"),
                    line: this.querySelector(".plug-range-slider__line"),
                    lineLabels: Array.from(this.getElementsByClassName("plug-range-slider__line-label")),
                    slider: this.querySelector(".plug-range-slider__slider")
                };
                this.controlWidth = this.elements.controlStart.getBoundingClientRect().width;
                this.setState(Number(this.dataset.currentStartValue), Number(this.dataset.currentEndValue));
                this.removeListeners = this.initListeners()
            }
            disconnectedCallback() {
                this.removeListeners()
            }
            computeValueUnitPerPx() {
                return this.totalRange / this.elements.line.getBoundingClientRect().width
            }
            initListeners() {
                const removeStartControlListeners = this.initStartControl();
                const removeEndControlListeners = this.initEndControl();
                const removeTextInputListeners = this.initTextInputListeners();
                return () => {
                    removeStartControlListeners();
                    removeEndControlListeners();
                    removeTextInputListeners()
                }
            }
            onChange(callback) {
                this.onChangeHandlers.push(callback)
            }
            emitChange(startValue, endValue) {
                this.onChangeHandlers.forEach((handler => {
                    handler(startValue, endValue)
                }))
            }
            getValue() {
                if (this.minValue !== this.currentStartValue || this.maxValue !== this.currentEndValue) {
                    return [this.currentStartValue, this.currentEndValue]
                } else {
                    return undefined
                }
            }
            initTextInputListeners() {
                const {
                    textInputStart,
                    textInputEnd
                } = this.elements;
                const handleTextInputStartChange = e => {
                    const strValue = textInputStart.value;
                    const newValue = Math.min(this.currentEndValue, Math.max(this.minValue, parseInt(strValue, 10)));
                    this.setState(newValue)
                };
                const handleTextInputEndChange = () => {
                    const strValue = textInputEnd.value;
                    const newValue = Math.max(this.currentStartValue, Math.min(this.maxValue, parseInt(strValue, 10)));
                    this.setState(undefined, newValue)
                };
                textInputStart.addEventListener("change", handleTextInputStartChange, false);
                textInputEnd.addEventListener("change", handleTextInputEndChange, false);
                return () => {
                    textInputStart.removeEventListener("change", handleTextInputStartChange, false);
                    textInputEnd.removeEventListener("change", handleTextInputEndChange, false)
                }
            }
            initStartControl() {
                const control = this.elements.controlStart;
                let isDragging = false;
                let valueUnitPerPx = this.computeValueUnitPerPx();
                let dragStartValue;
                const handlePointerUp = () => {
                    isDragging = false;
                    if (this.currentStartValue !== dragStartValue) {
                        this.emitChange(this.currentStartValue, this.currentEndValue)
                    }
                };
                const handlePointerMove = e => {
                    if (!isDragging) return;
                    if (e.movementY === 0 && e.movementX === 0) {
                        return
                    }
                    const currentValue = this.currentStartValue;
                    const valueDelta = Math.round(e.movementX * valueUnitPerPx);
                    const newValue = Math.min(this.currentEndValue, Math.max(this.minValue, currentValue + valueDelta));
                    this.setState(newValue)
                };
                const handlePointerDown = e => {
                    dragStartValue = this.currentStartValue;
                    valueUnitPerPx = this.computeValueUnitPerPx();
                    control.setPointerCapture(e.pointerId);
                    control.addEventListener("pointerup", handlePointerUp, false);
                    control.addEventListener("pointermove", handlePointerMove, false);
                    isDragging = true
                };
                control.addEventListener("pointerdown", handlePointerDown, false);
                control.ondragstart = () => false;
                return () => {
                    control.removeEventListener("pointerdown", handlePointerDown, false);
                    control.removeEventListener("pointerup", handlePointerUp, false);
                    control.removeEventListener("pointermove", handlePointerMove, false);
                    control.ondragstart = null
                }
            }
            initEndControl() {
                const control = this.elements.controlEnd;
                let isDragging = false;
                let valueUnitPerPx = this.computeValueUnitPerPx();
                let dragStartValue;
                const handlePointerUp = () => {
                    isDragging = false;
                    if (this.currentStartValue !== dragStartValue) {
                        this.emitChange(this.currentStartValue, this.currentEndValue)
                    }
                };
                const handlePointerMove = e => {
                    if (!isDragging) return;
                    if (e.movementY === 0 && e.movementX === 0) {
                        return
                    }
                    const currentValue = this.currentEndValue;
                    const valueDelta = Math.round(e.movementX * valueUnitPerPx);
                    const newValue = Math.max(this.currentStartValue, Math.min(this.maxValue, currentValue + valueDelta));
                    this.setState(undefined, newValue)
                };
                const handlePointerDown = e => {
                    dragStartValue = this.currentEndValue;
                    valueUnitPerPx = this.computeValueUnitPerPx();
                    control.setPointerCapture(e.pointerId);
                    control.addEventListener("pointerup", handlePointerUp, false);
                    control.addEventListener("pointermove", handlePointerMove, false);
                    isDragging = true
                };
                control.addEventListener("pointerdown", handlePointerDown, false);
                control.ondragstart = () => false;
                return () => {
                    control.removeEventListener("pointerdown", handlePointerDown, false);
                    control.removeEventListener("pointerup", handlePointerUp, false);
                    control.removeEventListener("pointermove", handlePointerMove, false);
                    control.ondragstart = null
                }
            }
            setState(startValue, endValue) {
                let startProgress;
                let endProgress;
                if (startValue !== undefined) {
                    this.currentStartValue = startValue;
                    startProgress = (startValue - this.minValue) / this.totalRange;
                    this.setControlPosition(this.elements.controlStart, startProgress)
                }
                if (endValue !== undefined) {
                    this.currentEndValue = endValue;
                    endProgress = 1 - (endValue - this.minValue) / this.totalRange;
                    this.setControlPosition(this.elements.controlEnd, endProgress)
                }
                this.elements.slider.setAttribute("aria-valuetext", `from ${this.currentStartValue} to ${this.currentEndValue}`);
                this.elements.slider.setAttribute("aria-valuenow", `${this.currentStartValue},${this.currentEndValue}`);
                this.setActiveLinePosition(startProgress, endProgress);
                this.setTextInputValues(startValue, endValue)
            }
            setTextInputValues(startValue, endValue) {
                if (startValue !== undefined) {
                    this.elements.textInputStart.value = startValue
                }
                if (endValue !== undefined) {
                    this.elements.textInputEnd.value = endValue
                }
            }
            setControlPosition(control, progress) {
                const prop = control.classList.contains("plug-control-start") ? "left" : "right";
                control.style[prop] = `calc(${progress*100}% - ${this.controlWidth/2}px)`
            }
            setActiveLinePosition(progressStart, progressEnd) {
                if (progressStart !== undefined) {
                    this.elements.activeLine.style.left = `${progressStart*100}%`
                }
                if (progressEnd !== undefined) {
                    this.elements.activeLine.style.right = `${progressEnd*100}%`
                }
            }
        }
        if (!customElements.get("plug-range-slider")) {
            customElements.define("plug-range-slider", PlugRangeSlider)
        }
    })();
    PLUG.Filters = function(config = {}) {
        const {
            checkboxFilterCardTemplateId,
            rangeFilterCardTemplateId,
            collectionFilterCardTemplateId,
            container
        } = config;
        const checkboxFilterCardTemplate = document.getElementById(checkboxFilterCardTemplateId);
        const rangeFilterCardTemplate = document.getElementById(rangeFilterCardTemplateId);
        const collectionFilterCardTemplate = collectionFilterCardTemplateId ? document.getElementById(collectionFilterCardTemplateId) : null;
        const customFilters = [{
            attribute: "snize_facet1",
            title: "Child Collections"
        }];

        function buildFilterCard(facet) {
            if (facet.attribute === "collections" || facet.attribute === "snize_facet1") {
                if (PLUG.requestPageType === "collection") {
                    return buildCollectionFilterCard(facet)
                }
            } else if (facet.type === "select") {
                return buildCheckboxFilterCard(facet)
            } else if (facet.type === "slider") {
                return buildRangeFilterCard(facet)
            } else {
                console.log(`PLUG.Filters Error: Unrecognized filter type: ${facet.type}.`)
            }
        }

        function getActiveFilters() {
            const cards = Array.from(container.getElementsByClassName("filter-card"));
            return cards.reduce(((filters, card) => {
                if (card.classList.contains("filter-card--checkboxes")) {
                    const checkedButtons = Array.from(card.querySelectorAll(".filter-card__list-item-button[data-checked='true']"));
                    const values = [];
                    checkedButtons.forEach((button => {
                        values.push(button.dataset.value)
                    }));
                    if (values.length) {
                        filters[card.dataset.attribute] = values
                    }
                } else if (card.classList.contains("filter-card--range")) {
                    const plugRangeSlider = card.querySelector("plug-range-slider");
                    const value = plugRangeSlider.getValue();
                    if (value !== undefined) {
                        filters[card.dataset.attribute] = [value.join(",")]
                    }
                }
                return filters
            }), {})
        }

        function initFilterCardListeners(card, onChange) {
            const headingButton = card.querySelector(".filter-card__heading-button");
            headingButton.addEventListener("click", (() => {
                const wasExpanded = card.dataset.state === "expanded";
                if (wasExpanded) {
                    card.dataset.state = "collapsed"
                } else {
                    card.dataset.state = "expanded"
                }
            }));
            if (card.classList.contains("filter-card--checkboxes")) {
                const buttons = Array.from(card.getElementsByClassName("filter-card__list-item-button"));
                buttons.forEach((button => {
                    button.addEventListener("click", (() => {
                        const wasChecked = button.dataset.checked === "true";
                        button.dataset.checked = wasChecked ? "false" : "true";
                        if (button.dataset.attribute === "collections") {
                            if (!wasChecked) {
                                buttons.forEach((b => {
                                    if (b.dataset.checked === "true" && b.dataset.value !== button.dataset.value) {
                                        b.dataset.checked = "false"
                                    }
                                }))
                            }
                        }
                        onChange().catch((err => console.error(err)))
                    }))
                }))
            } else if (card.classList.contains("filter-card--range")) {
                const plugRangeSlider = card.querySelector("plug-range-slider");
                plugRangeSlider.onChange(((startValue, endValue) => {
                    onChange().catch((err => console.error(err)))
                }))
            }
        }

        function buildCheckboxFilterCard(facet) {
            const currentFilterCard = document.querySelector(`.filter-card[data-attribute="${facet.attribute}"]`);
            const card = checkboxFilterCardTemplate.content.cloneNode(true).querySelector(".filter-card");
            card.querySelector("[data-filter-title]").textContent = facet.title;
            card.dataset.attribute = facet.attribute;
            const list = card.querySelector(".filter-card__list");
            const listItem = list.removeChild(list.querySelector("li"));
            const selectedValues = facet.buckets.filter((bucket => bucket.selected === "true")).map((bucket => bucket.value));
            facet.buckets.forEach((bucket => {
                if (Number(bucket.count) < 1) {
                    return
                }
                const li = listItem.cloneNode(true);
                const button = li.querySelector(".filter-card__list-item-button");
                const a = document.createElement("a");
                a.className = "filter-card__list-item-link";
                button.dataset.value = bucket.value;
                button.dataset.checked = selectedValues.includes(bucket.value) ? "true" : "false";
                li.querySelector(".filter-card__value").textContent = bucket.value;
                li.querySelector(".filter-card__count").textContent = `(${bucket.count})`;
                list.appendChild(li)
            }));
            if (currentFilterCard) {
                const numNewCardListItems = card.querySelectorAll(".filter-card__list-item").length;
                const numOldCardListItems = currentFilterCard.querySelectorAll(".filter-card__list-item").length;
                if (numNewCardListItems === numOldCardListItems) {
                    card.querySelector(".filter-card__list").scrollTop = currentFilterCard.querySelector(".filter-card__list").scrollTop;
                    card.dataset.initialScrollTop = String(currentFilterCard.querySelector(".filter-card__list").scrollTop)
                }
            }
            return card
        }

        function buildCollectionFilterCard(facet) {
            if (PLUG.requestPageType !== "collection") {
                return
            }
            const childCollections = PLUG.collection.children;
            if (childCollections.length === 0) {
                return
            }
            const parent = PLUG.collection;
            const collections = [parent].concat(childCollections);
            const card = collectionFilterCardTemplate.content.cloneNode(true).querySelector(".filter-card");
            card.querySelector("[data-filter-title]").textContent = "Collection";
            const list = card.querySelector(".filter-card__list");
            const listItem = list.removeChild(list.querySelector("li"));
            collections.forEach(((collection, index) => {
                const li = listItem.cloneNode(true);
                const a = li.querySelector(".filter-card__list-item-button");
                const searchParams = new URLSearchParams([
                    ["l1", `${PLUG.collection.handle}|${PLUG.collection.title}`]
                ]);
                a.dataset.checked = index === 0 ? "true" : "false";
                a.href = `${collection.url}?${searchParams.toString()}`;
                if (facet) {
                    const bucket = facet.buckets.find((bucket => bucket.value === collection.title));
                    if (!bucket) return;
                    const count = Number(bucket.count);
                    if (count < 1) return;
                    li.querySelector(".filter-card__value").textContent = bucket.value;
                    li.querySelector(".filter-card__count").textContent = `(${bucket.count})`
                } else {
                    li.querySelector(".filter-card__value").textContent = collection.title
                }
                list.appendChild(li)
            }));
            return card
        }

        function buildRangeFilterCard(facet) {
            const card = rangeFilterCardTemplate.content.cloneNode(true).querySelector(".filter-card");
            const titleEle = card.querySelector("[data-filter-title]");
            titleEle.textContent = facet.title;
            card.dataset.attribute = facet.attribute;
            const minNum = Math.floor(Number(facet.buckets[0].from));
            const maxNum = Math.ceil(Number(facet.buckets[0].to));
            const startNum = Math.floor(Number(facet.buckets[0].left));
            const endNum = Math.ceil(Number(facet.buckets[0].right));
            const min = String(minNum);
            const max = String(maxNum);
            const start = String(startNum);
            const end = String(endNum);
            const plugRangeSlider = card.querySelector("plug-range-slider");
            plugRangeSlider.dataset.currentStartValue = start;
            plugRangeSlider.dataset.currentEndValue = end;
            plugRangeSlider.dataset.minValue = min;
            plugRangeSlider.dataset.maxValue = max;
            const slider = plugRangeSlider.querySelector(".plug-range-slider__slider");
            slider.setAttribute("aria-valuemin", min);
            slider.setAttribute("aria-valuemax", max);
            slider.setAttribute("aria-valuetext", `from ${start} to ${end}`);
            slider.setAttribute("aria-valuenow", `${start},${end}`);
            titleEle.setAttribute("id", `plug-filters-title-${facet.attribute}`);
            slider.setAttribute("aria-labelledby", `plug-filters-title-${facet.attribute}`);
            card.querySelector("[data-range-start]").setAttribute("aria-label", `Start of ${facet.attribute} range.`);
            card.querySelector("[data-range-end]").setAttribute("aria-label", `End of ${facet.attribute} range.`);
            const lineLabels = Array.from(card.getElementsByClassName("plug-range-slider__line-label"));
            lineLabels.forEach(((label, index) => {
                if (index === 0) {
                    label.textContent = String(minNum)
                } else if (index === lineLabels.length - 1) {
                    label.textContent = String(maxNum)
                } else {
                    label.textContent = String(Math.round(.25 * index * (maxNum - minNum)))
                }
            }));
            return card
        }
        return Object.freeze({
            initFilterCardListeners,
            buildFilterCard,
            buildCollectionFilterCard,
            getActiveFilters
        })
    };
    (function(CollectionTemplate) {
        const chainLengthVariantMetafieldFilter = "filter_variant_metafield_7b3ff6735de67085b56b3b71cd118c04";

        function init() {
            try {
                initPlugCollection();
                setupArticlesSlider()
            } catch (exception) {
                console.log("Error setting up articles slider.", exception)
            }
        }

        function initPlugCollection() {
          console.log("fdsfdsfsdf");
            const pageSize = 24;
            const U = PLUG.Utils.export();
            const ProductCard = PLUG.ProductCard.export();
            class PlugCollection extends HTMLElement {
                constructor() {
                    super();
                    U.bindThisToAllMethods(this)
                }
                connectedCallback() {
                    console.log("Heard PlugCollection connectedCallback");
                    this.filtersContainer = this.querySelector(".c-filters__cards");
                    this.grid = this.querySelector(".c-product-cards");
                    if (!this.grid || !this.filtersContainer) {
                        return
                    }
                    this.resultsCount = this.querySelector(".c-item-count");
                    this.paginationLabel = this.querySelector(".c-pagination__label");
                    this.paginationLoadMoreButton = this.querySelector(".c-pagination__load-more-button");
                    const sortingListboxEle = document.getElementById("c-sorting-listbox");
                    this.totalItemCount = 0;
                    const apiKey = this.dataset.snizeApiKey;
                    this.searchApi = PLUG.SearchApi({
                        apiKey,
                        pageSize
                    });
                    this.filters = PLUG.Filters({
                        checkboxFilterCardTemplateId: this.dataset.checkboxFilterCardTemplate,
                        rangeFilterCardTemplateId: this.dataset.rangeFilterCardTemplate,
                        collectionFilterCardTemplateId: PLUG.requestPageType === "collection" ? this.dataset.collectionFilterCardTemplate : "",
                        container: this.filtersContainer
                    });
                    const initialSearchParams = this.decodeSearchParams();
                    if (PLUG.requestPageType === "search") {
                        this.query = initialSearchParams.query;
                        this.searchForm = this.querySelector(".s-form");
                        this.searchInput = this.querySelector(".plug-search-page-input");
                        this.searchForm.addEventListener("submit", (e => {
                            e.preventDefault()
                        }));
                        const handleSearchInputChange = () => {
                            this.query = this.searchInput.value;
                            this.renderPage(1).catch((err => console.error(err)))
                        };
                        this.searchInput.addEventListener("change", handleSearchInputChange, false)
                    }
                    if (initialSearchParams.sort.criteria && initialSearchParams.sort.criteria.toLowerCase() !== "featured") {
                        const sortValue = this.searchApi.paramsToSortValue(initialSearchParams.sort);
                        const listItems = Array.from(sortingListboxEle.getElementsByClassName("listbox-option"));
                        const matchingListItem = listItems.find((li => li.textContent === sortValue));
                        if (matchingListItem) {
                            sortingListboxEle.querySelector(".listbox-value").textContent = sortValue;
                            listItems.forEach((listItem => {
                                if (listItem.textContent !== sortValue) {
                                    listItem.removeAttribute("aria-selected")
                                } else {
                                    listItem.setAttribute("aria-selected", "true")
                                }
                            }))
                        }
                    }
                    this.sortListbox = U.listboxConstructor(sortingListboxEle, ((selectedLi, listbox) => {
                        this.activeSort = selectedLi.textContent;
                        this.renderPage(1).catch((error => console.log(error)))
                    }));
                    this.activeSort = this.sortListbox.getValue();
                    if (this.paginationLoadMoreButton) {
                        this.paginationLoadMoreButton.addEventListener("click", this.loadNextPage)
                    }
                    this.initMobileMenu();
                    this.renderPage(1, initialSearchParams.filters, initialSearchParams.sort).catch((error => console.log(error)))
                }
                async renderPage(pageNum = 1, filters, sort) {
                    console.log(`Rendering page ${pageNum}...`);
                    const t0 = Date.now();
                    const config = {
                        pageNum,
                        filters: filters ? filters : this.filters.getActiveFilters(),
                        sort: sort && sort.criteria && sort.order ? this.searchApi.sortValueToParams(sort.criteria) : this.searchApi.sortValueToParams(this.activeSort)
                    };
                    if (PLUG.requestPageType === "collection") {
                        config.collection = {
                            title: PLUG.collection.title,
                            handle: PLUG.collection.handle
                        }
                    } else if (PLUG.requestPageType === "search") {
                        config.query = this.query
                    }
                    const {
                        products,
                        facets,
                        totalItemCount
                    } = await this.searchApi.fetchResults(config);
                    this.updateSearchParams({
                        pageNum,
                        filters: config.filters,
                        sort: {
                            criteria: this.activeSort,
                            order: config.sort.order
                        }
                    });
                    this.totalItemCount = totalItemCount;
                    if (this.resultsCount) {
                        this.resultsCount.textContent = `${totalItemCount} Products`
                    }
                    this.updatePagination(pageNum, totalItemCount);
                    this.renderProductCards(products, pageNum);
                    this.renderFilterCards(facets);
                    U.updateAllFavoriteButtons().catch((e => console.error(e)));
                    console.log(`Time to render page: ${Date.now()-t0}ms.`)
                }
                loadNextPage() {
                    const {
                        pageNum
                    } = this.decodeSearchParams();
                    const totalItemCount = this.totalItemCount;
                    if (pageNum * pageSize >= totalItemCount) {
                        return
                    }
                    if (this.paginationLoadMoreButton) {
                        U.setButtonLoadingState(this.paginationLoadMoreButton, true)
                    }
                    this.renderPage(pageNum + 1).catch((err => console.error(err))).finally((() => {
                        if (this.paginationLoadMoreButton) {
                            U.setButtonLoadingState(this.paginationLoadMoreButton, false)
                        }
                    }))
                }
                renderProductCards(products, pageNum) {
                    // Build cards defensively so one malformed product can't blank the whole grid.
                    const productCards = products.map(((product, index) => {
                        try {
                            return this.buildProductCard(product, index)
                        } catch (cardError) {
                            console.error("Failed to build product card:", cardError, product);
                            return null
                        }
                    })).filter((card => card));
                    if (pageNum === 1) {
                        U.removeChildren(this.grid)
                    }
                    if (pageNum === 1 && productCards.length === 0) {
                        const emptyEl = document.createElement("p");
                        emptyEl.className = "c-empty-state";
                        emptyEl.textContent = (!products || products.length === 0) ? "No products found." : "We couldn't load products right now. Please refresh the page or try again shortly.";
                        this.grid.appendChild(emptyEl);
                        return
                    }
                    const productsDocFrag = document.createDocumentFragment();
                    productCards.forEach((card => {
                        productsDocFrag.appendChild(card)
                    }));
                    this.grid.appendChild(productsDocFrag)
                }
                renderFilterCards(facets) {
                    const nonEmptyFacets = facets.filter((facet => facet.type === "slider" || facet.buckets.some((bucket => Number(bucket.count) > 1))));
                    const filterCards = nonEmptyFacets.map((facet => this.filters.buildFilterCard(facet))).filter((card => card !== undefined));
                    const filtersDocFrag = document.createDocumentFragment();
                    filterCards.forEach((card => filtersDocFrag.appendChild(card)));
                    U.removeChildren(this.filtersContainer);
                    this.filtersContainer.appendChild(filtersDocFrag);
                    filterCards.forEach((filterCard => {
                        if (filterCard.dataset.initialScrollTop) {
                            filterCard.querySelector(".filter-card__list").scrollTop = Number(filterCard.dataset.initialScrollTop)
                        }
                        this.filters.initFilterCardListeners(filterCard, this.renderPage)
                    }))
                }
                updatePagination(pageNum, totalItemCount) {
                    if (this.paginationLabel) {
                        const firstIndex = (pageNum - 1) * pageSize + 1;
                        const lastIndex = Math.min(firstIndex + (pageSize - 1), totalItemCount);
                        this.paginationLabel.textContent = `1 - ${lastIndex} of ${totalItemCount} Products`
                    }
                    if (this.paginationLoadMoreButton) {
                        if (pageNum * pageSize >= totalItemCount) {
                            this.paginationLoadMoreButton.classList.add("is-hidden")
                        } else {
                            this.paginationLoadMoreButton.classList.remove("is-hidden")
                        }
                    }
                }
                updateSearchParams(paramsData) {
                    const urlSearchParams = this.encodeSearchParams(paramsData);
                    const url = new URL(location.href);
                    url.search = `?${urlSearchParams.toString()}`;
                    window.history.replaceState(null, "", url.toString())
                }
                decodeSearchParams() {
                    const data = {
                        pageNum: 1,
                        sort: {
                            criteria: undefined,
                            order: undefined
                        },
                        filters: {}
                    };
                    const searchParams = new URLSearchParams(window.location.search);
                    for (const [key, value] of searchParams.entries()) {
                        if (key === "page" && value) {
                            data.pageNum = Number(value)
                        } else if (key === "sortBy" && value) {
                            data.sort.criteria = value
                        } else if (key === "sortOrder" && value) {
                            data.sort.order = value
                        } else if (key.startsWith("pd_f_") && value !== "") {
                            data.filters[key.replace("pd_f_", "")] = value.split("|")
                        } else if (key === "q") {
                            data.query = value
                        }
                    }
                    return data
                }
                encodeSearchParams(data) {
                    const {
                        pageNum,
                        sort,
                        filters
                    } = data;
                    const params = [];
                    Object.keys(filters).forEach((attribute => {
                        const values = filters[attribute];
                        params.push([`pd_f_${attribute}`, values.join("|")])
                    }));
                    if (sort && sort.criteria && sort.order) {
                        params.push(["sortBy", sort.criteria], ["sortOrder", sort.order])
                    }
                    if (typeof pageNum === "number" && pageNum > 1) {
                        params.push(["page", String(pageNum)])
                    }
                    if (PLUG.requestPageType === "search") {
                        params.push(["q", this.query])
                    }
                    const oldSearchParams = new URLSearchParams(window.location.search);
                    for (const [key, value] of oldSearchParams.entries()) {
                        if (key !== "page" && key !== "sortBy" && key !== "sortOrder" && !key.startsWith("pd_f_") && key !== "q") {
                            params.push([key, value])
                        }
                    }
                    return new URLSearchParams(params)
                }
                buildProductCard(product, index) {
                    const avgScore = product.rating ? product.rating.average : 0;
                    const numReviews = product.rating ? product.rating.count : 0;
                    const variant = product.variants[0];
                    const card = document.createElement("div");
                    card.className = "product-card";
                    card.dataset.productId = product.id;
                    card.dataset.variantId = variant.id;
                    const cardInner = document.createElement("a");
                    cardInner.className = "product-card-inner";
                    if (PLUG.requestPageType === "collection" && !product.url.includes("/collections/")) {
                        cardInner.href = `${PLUG.collection.url}${product.url}`
                    } else {
                        cardInner.href = `${PLUG.rootUrl!=="/"?PLUG.rootUrl:""}${product.url}`
                    }
                    card.appendChild(cardInner);
                    const imgWrapper = document.createElement("div");
                    imgWrapper.className = "product-card-img-wr";
                    const ratioBox = document.createElement("div");
                    ratioBox.className = "ratio-box ratio-box-square";
                    cardInner.appendChild(imgWrapper);
                    imgWrapper.appendChild(ratioBox); 
                    if (product.images && product.images.length) {
                        const img = PlugCollection.buildImage(product.images[0], product.title, index < 3 ? "eager" : "lazy", 1);
                        ratioBox.appendChild(img)
                      if (product.images && product.images.length > 1) {
                        const img = PlugCollection.buildImage(product.images[1], product.title, index < 3 ? "eager" : "lazy", product.images.length);
                        ratioBox.appendChild(img)
                      }
                    }
                    const favButton = U.buildCardFavButton(Number(product.id), Number(variant.id), `https://pepitools.com${product.url}`, product.title, !product.images || !product.images.length ? undefined : product.images[0].includes("?") ? `${product.images[0]}&width=180` : `${product.images[0]}?width=180`);
                    card.appendChild(favButton);
                    const productdetails = document.createElement("div");
                    productdetails.className = "product-detail-with-btn-prc";
                    cardInner.appendChild(productdetails);
                    const topMeta = document.createElement("div");
                    topMeta.className = "product-card-top-meta";
                    productdetails.appendChild(topMeta);
                    const title = document.createElement("p");
                    title.className = "product-card-title";
                    title.textContent = product.title;
                    topMeta.appendChild(title);
                    const score = document.createElement("p");
                    score.className = "product-card-score";
                    // if (numReviews === 0) {
                    //     score.style.opacity = "0"
                    // }
                    // let k = 1;
                    // while (k <= 5) {
                    //     const star = U.buildStar(k > Math.ceil(Number(avgScore)));
                    //     score.appendChild(star);
                    //     k += 1
                    // }
                    const junipSpan = document.createElement("span");
                    junipSpan.className = "junip-product-summary";
                    junipSpan.dataset.productId = product.id;
                    junipSpan.dataset.productRatingCount = product.metafields?.junip?.rating_count || 0;
                    junipSpan.dataset.productRatingAverage = product.metafields?.junip?.rating_average || 0;
                    score.appendChild(junipSpan);
                    // const reviewCount = document.createElement("span");
                    // reviewCount.className = "product-card-review-count";
                    // reviewCount.textContent = `(${numReviews})`;
                    // score.appendChild(reviewCount);
                    topMeta.appendChild(score);
                    const sku = document.createElement("p");
                    sku.className = "product-card-sku";
                    sku.textContent = "SKU# " + variant.sku;
                    topMeta.appendChild(sku);
                    const PricewithCta = document.createElement("div");
                    PricewithCta.className = "product-card-price-with-cta";
                    productdetails.appendChild(PricewithCta);
                    const Ctabuttondiv = document.createElement("div");
                    Ctabuttondiv.className = "product-card-cta-button";
                    PricewithCta.appendChild(Ctabuttondiv);
                    const learnmorebutton = document.createElement("div");
                    learnmorebutton.className = "product-card-viewmore";
                    learnmorebutton.textContent = "Learn More";
                    PricewithCta.appendChild(learnmorebutton);
                    const priceOptions = {};
                    const variantMetafieldData = variant.filterMetafieldData;
                    if (variantMetafieldData && typeof variantMetafieldData === "object" && variantMetafieldData[chainLengthVariantMetafieldFilter] && variantMetafieldData[chainLengthVariantMetafieldFilter].includes("[:TYPE_DELIM:]")) {
                        priceOptions.chainLengthFt = Number(variantMetafieldData[chainLengthVariantMetafieldFilter].split("[:TYPE_DELIM:]")[1])
                    }
                    const price = ProductCard.computePrice(variant.price * 100, product.tags);
                    const compareAtPrice = ProductCard.computeCompareAtPrice(variant.price * 100, variant.compareAtPrice * 100, product.tags);
                    const priceRow = ProductCard.buildPriceRow(product.available, price, compareAtPrice, product.tags, priceOptions, product.availablequantity);
                    PricewithCta.appendChild(priceRow);
                    ProductCard.buildBadge(product.tags, card);
                    return card
                }
                initMobileMenu() {
                    const filterOuterContainer = this.querySelector(".c-filters");
                    const openButton = this.querySelector(".c-filters-mobile-menu-button");
                    const closeButton = this.querySelector(".c-filters__mobile-close-button");
                    const overlay = this.querySelector(".c-filters__mobile-overlay");
                    const showResultsButton = this.querySelector(".c-filters__apply-button");

                    function closeMenu() {
                        document.body.classList.remove("is-unscrollable");
                        filterOuterContainer.classList.remove("is-open")
                    }

                    function openMenu() {
                        document.body.classList.add("is-unscrollable");
                        filterOuterContainer.classList.add("is-open")
                    }
                    document.getElementById("main").addEventListener("mobileToDesktopResize", (() => {
                        closeMenu()
                    }));
                    if (openButton) {
                        openButton.addEventListener("click", openMenu)
                    }
                    if (closeButton) {
                        closeButton.addEventListener("click", closeMenu)
                    }
                    if (overlay) {
                        overlay.addEventListener("click", closeMenu)
                    }
                    if (showResultsButton) {
                        showResultsButton.addEventListener("click", closeMenu)
                    }
                }
                static buildImage(imageSrc, imageAlt, loading = "lazy", length) {
                    const img = document.createElement("img");
                    img.loading = loading;
                    img.alt = imageAlt;
                    img.src = imageSrc;
                    img.className = "ratio-img full-width";
                    if (length > 1) {
                        img.classList.add("second-img-hover");
                    }
                    img.srcset = U.formatImageSrcset(imageSrc, 1200, [200, 300, 400, 600, 800, 1e3, 1200]);
                    img.sizes = ["(max-width: 424px) calc(100vw - 44px)", "(max-width: 599px) calc((100vw - 128px) / 2)", "(max-width: 767px) calc((100vw - 196px) / 2)", "(max-width: 1023px) calc(((100vw - 100px) * .75 - 100px) / 2)", "(max-width: 1515px) calc(((100vw - 100px) * .75 - 160px) / 3)", "278px"].join(", ");
                    img.setAttribute("draggable", "false");
                    return img
                }
            }
            customElements.define("plug-collection", PlugCollection)
        }

        function setupArticlesSlider() {
            const sliderEle = document.getElementById("c-articles-slider");
            if (sliderEle) {
                return new Flickity(sliderEle, {
                    contain: true,
                    wrapAround: false,
                    prevNextButtons: false,
                    pageDots: false,
                    cellAlign: "left"
                })
            }
        }
        CollectionTemplate.export = function() {
            return Object.freeze({
                init
            })
        }
    })(PLUG.CollectionInstructionalVideoTemplate = Object.create(null))
})();